import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import './i18n'; // Import i18n configuration
import { HelmetProvider } from 'react-helmet-async';
import { initSentry, SentryErrorBoundary } from './utils/sentry';

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
